import {
  DISMISS_ATTACHMENT_ERROR,
  INSERT_ATTACHMENT_FAIL,
  LOADING_ATTACHMENT,
  LOAD_ATTACHMENTS_FOR_ASSET
} from '../actions';

export const initialState = {
  attachments: {
    entities: {},
    ids: []
  },
  error: null,
  loading: false
};

const attachment = (state = initialState, action) => {
  switch (action.type) {
    case DISMISS_ATTACHMENT_ERROR:
      return {
        ...state,
        error: null
      };
    case INSERT_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.error.message
      };
    case LOADING_ATTACHMENT:
      return {
        ...state,
        loading: action.loading
      };
    case LOAD_ATTACHMENTS_FOR_ASSET:
      return {
        ...state,
        loading: false,
        attachments: {
          entities: {
            ...state.attachments.entities,
            ...action.attachments.reduce((map, attachment) => {
              map[attachment.id] = attachment;
              return map;
            }, {})
          },
          // TODO: pretty sure we can drop `...state.attachments.ids` because we get dupes
          ids: [...state.attachments.ids, ...action.attachments.map(attachment => attachment.id)]
        }
      };
    default:
      return state;
  }
};

export default attachment;



// WEBPACK FOOTER //
// ./src/reducers/attachment.js